import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { childTokenGuard } from './Guards/child-token.guard';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';

const routes: Routes = [
	{
		path: '', redirectTo: '/login', pathMatch: 'full'
	},
	{
		path: 'refresh', component: RefreshComponent
	},
	{
		path: 'login', component: LoginComponent

	},
	{
		path: 'forgot-password', component: ResetPasswordNewComponent
	},
	{
		path: 'app', canActivate: [childTokenGuard], data: { breadcrumb: 'TopNavBar' }, loadChildren: () => import('./navbar/navbar.module').then(m => m.NavbarModule)
	},
	{
		path: 'joinCall', loadChildren: () => import('./videocall/videocall.module').then(m => m.VideocallModule)
	},
	{
		path: 'terms', loadChildren: () => import('./policies/policies.module').then(m => m.PoliciesModule)
	},
	{ path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
